(function () {
  function init() {
    var root = document.getElementById('pbm-calc');
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    var turnover = root.querySelector('#pbm-turnover');
    var foreign = root.querySelector('#pbm-foreign');
    var turnoverVal = root.querySelector('#pbm-turnover-val');
    var foreignVal = root.querySelector('#pbm-foreign-val');
    var rateOut = root.querySelector('#pbm-rate');
    var monthOut = root.querySelector('#pbm-monthly');
    var yearOut = root.querySelector('#pbm-yearly');
    var tabs = root.querySelectorAll('.pbm-calc-tab');
    if (!turnover || !foreign || !rateOut) return;

    var planFee = 2;
    var activeTab = root.querySelector('.pbm-calc-tab.active');
    if (activeTab) {
      var f = parseFloat(activeTab.getAttribute('data-fee'));
      if (!isNaN(f)) planFee = f;
    }

    function fmtNum(n) {
      try { return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(Math.round(n)); }
      catch (e) { return String(Math.round(n)); }
    }
    function fmtPct(n) { return n.toFixed(2).replace('.', ',') + ' %'; }

    function recalc() {
      var t = parseInt(turnover.value, 10) || 0;
      var fr = parseInt(foreign.value, 10) || 0;
      var monoBlended = 1.3 * (100 - fr) / 100 + 2.0 * fr / 100;
      var totalRate = monoBlended + 0.4 + 0.35 + planFee;
      var monthly = t * totalRate / 100;
      if (turnoverVal) turnoverVal.textContent = fmtNum(t) + ' ₴';
      if (foreignVal) foreignVal.textContent = fr + ' %';
      rateOut.textContent = fmtPct(totalRate);
      if (monthOut) monthOut.textContent = fmtNum(monthly) + ' ₴';
      if (yearOut) yearOut.textContent = fmtNum(monthly * 12) + ' ₴';
    }

    turnover.addEventListener('input', recalc);
    foreign.addEventListener('input', recalc);
    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener('click', function () {
        Array.prototype.forEach.call(tabs, function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var fee = parseFloat(tab.getAttribute('data-fee'));
        if (!isNaN(fee)) planFee = fee;
        recalc();
      });
    });
    recalc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
